import { gsap, ScrollTrigger } from 'gsap/all';
import { isMobile } from '../helpers/functions';
import { breakpoints } from '../helpers/constants';
import { snapToFrame } from './base-animation';
gsap.registerPlugin(ScrollTrigger);
const init = () => {
  const mm = gsap.matchMedia();
  const devicePreview = document.querySelectorAll('.frame-type-device_preview');
  gsap.utils.toArray(devicePreview).forEach(($el, index) => {
    const triggerEl = $el.querySelector('.device-preview');
    const isLast = index === devicePreview.length - 1;
    $el.dataset.index = `${index}`;
    snapToFrame($el);
    mm.add(`(min-width: ${breakpoints.md}px)`, () => {
      const st = gsap.timeline({
        scrollTrigger: {
          trigger: $el,
          start: 'bottom bottom',
          end: isLast ? 'center' : 'bottom',
          scrub: true,
          pin: true,
          pinSpacing: false
        }
      });
      st.to(triggerEl, {
        scale: 0.8,
        filter: 'blur(10px)',
        ease: 'linear'
      }).to($el, {
        opacity: 0
      });
    });
  });
  const tabEl = document.querySelectorAll('button[data-bs-toggle="tab"]');
  [...tabEl].forEach($el => {
    $el.addEventListener('shown.bs.tab', e => {
      const {
        target
      } = e;
      const {
        bsTarget
      } = target.dataset;
      const contentTarget = document.querySelector(bsTarget);
      if (!contentTarget) return;
      const video = contentTarget.querySelector('video');
      if (!video) return;
      video.load();
    });
  });
  const toggleMobileTab = () => {
    if (isMobile()) {
      [...document.querySelectorAll('.frame-type-device_preview .nav-tab[data-type="mobile"]')].forEach($el => {
        $el.click();
      });
    }
  };
  toggleMobileTab();
  document.addEventListener('containerResize', toggleMobileTab);
};
export default init;